var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fonts)?_c('div',{staticClass:"font-display"},[_c('p',{staticClass:"title is-3",style:({'font-family': _vm.fonts.title })},[_vm._v(_vm._s(_vm.fonts.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-4",style:({'font-family': _vm.fonts.paragraph })},[_vm._v(_vm._s(_vm.fonts.paragraph))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }